// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';

// TYPES ---------------------------------------------------------------- //

export interface OpsDriveProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const OpsDrive = ({ ...props }: OpsDriveProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.ops.main}
      extraWidthBeforeLabel={'PICKUP'}
      extraWidthBetweenLabel={'DRIVE'}
      extraWidthAfterLabel={'DELIVERY'}
      secondaryIcon={null}
      variant={'solid'}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default OpsDrive;
